import i18n from 'i18next';

import { useGetSortingFields } from '../../screens/Claims/LossAndDamage/hooks';
import FormSelectBox from '../Inputs/FormSelectBox';

const LADClaimsSortingSelector = ({
  placeholder = i18n.t('translation:default.fields.sortBy.select'),
  label = i18n.t('translation:default.fields.sortBy.label'),
  rules = [],
  name,
  editMode,
}) => {
  const { data = [], isLoading } = useGetSortingFields();
  const options = data.map((row) => ({
    label: row.value,
    value: row.key,
  }));

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin="mb-0"
      rules={rules}
      name={name}
      editMode={editMode}
      style={{ minWidth: 100, width: 100 }}
    />
  );
};

export default LADClaimsSortingSelector;
